import { _baseClient } from '../index';

export const getMasterData = () => {
  return _baseClient.get('/master-data');
};

export const getUnitMasterData = (params) => {
  return _baseClient.post('/unit-master-data', { body: params });
};

export const getClientMasterData = (params) => {
  return _baseClient.get('/client-master-data', params);
};
